'use strict';

const SELECTORS = {
    abDatePicker: '.js-ab-datepicker'
};

// Minimum age (in years) required for the birthday field. Mirrors the previous
// bootstrap-datepicker `endDate: '-14y'` constraint.
const MIN_AGE_YEARS = 16;

/**
 * Build an MM/dd/yyyy date string for N years before today. Used as the latest
 * selectable date so the entered birthday satisfies the minimum age requirement.
 * ab-datepicker parses `max` as a formatted string (no relative "-14y" syntax).
 * @param {number} years - number of years to subtract from today
 * @returns {string} date formatted as MM/dd/yyyy
 */
const yearsAgo = (years) => {
    const pad = (n) => (n < 10 ? '0' + n : String(n));
    const date = new Date();
    date.setFullYear(date.getFullYear() - years);

    return pad(date.getMonth() + 1) + '/' + pad(date.getDate()) + '/' + date.getFullYear();
};

/**
 * Initialize the accessible ab-datepicker on all matching inputs.
 * Relies on $.fn.abDatePicker exposed by friartux/thirdParty/abDatepicker.
 * @returns {void}
 */
const initAbDatepicker = () => {
    const maxDate = yearsAgo(MIN_AGE_YEARS);

    $(SELECTORS.abDatePicker).attr('data-max-date', maxDate).abDatePicker({
        markup: 'bootstrap4',
        theme: 'bootstrap',
        startView: 'years',
        firstDayOfWeek: 0,
        inputFormat: ['MM/dd/yyyy', 'M/d/yyyy'],
        outputFormat: 'MM/dd/yyyy',
        max: yearsAgo(1)
    });
};

module.exports = () => {
    initAbDatepicker();
};
